import { TimeService_timeServiceGetGetTime } from '@festina/datamart-general-types/datamart-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchDatamartTime = TimeService_timeServiceGetGetTime.useQuery
